import NotFound from 'pages/errors/not-found';

export default NotFound;
